<template>
    <div class="accordion accordion-flush">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button 
                    class="accordion-button"
                    :class="{'collapsed': !_.assets}" 
                    type="button" 
                    data-bs-toggle="collapse"
                    data-bs-target="#part-attachments" 
                    aria-expanded="false" 
                    aria-controls="part-attachments"
                    @click="_.assets = !_.assets"
                >
                    <span>Attachments (Receipts, Documents)</span>
                </button>
            </h2>
            <div class="accordion-collapse -collapse" v-if="_.assets">
                <div class="accordion-body">
                    <kt-upload @process="processFiles($event)" multiple="1"></kt-upload>

                    <table class="table table-sm table-striped mt-3" v-if="files.length">
                        <tbody>
                            <tr v-for="file in files" :key="file.Id">
                                <td style="width: 40px;">
                                    <button class="btn btn-sm" @click="showDelete(file)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                                <td>
                                    <a :href="'https://admin0.7thleveltech.com/v1/Data/Download/' + file.Id"
                                        target="_blank">
                                        {{ file.Title }}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="files.length === 0" class="text-muted text-center py-3">
                        <i class="fa fa-file"></i> No attachments yet
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onUnmounted } from "vue";
import Api from "@/services/Api";
import Alert from "@/services/Alert";
import KtUpload from "@/components/UI/KtUpload.vue";

const _ = ref({});
const files = ref([]);
const unwatch = [];

const props = defineProps({
    partId: {
        type: Number,
        default: 0
    },
    requestId: {
        type: Number,
        default: 0
    }
});

const load = async () => {
    if (!props.partId) {
        files.value = [];
        return;
    }
    
    try {
        files.value = await Api.loadPartFiles(props.partId);
    } catch (error) {
        console.error("Error loading part files:", error);
        files.value = [];
    }
};

const processFiles = async (uploadedFiles) => {
    if (!props.partId) {
        Alert.notify("Please save the part before attaching files.");
        return;
    }

    for (let i = 0; i < uploadedFiles.length; i++) {
        let file = uploadedFiles[i];
        var dta = new FormData();
        dta.append("File", file);
        dta.append("Type", "part");
        dta.append("RefId", props.partId);
        
        // Also include RequestId for context so attachments show up for the job
        if (props.requestId) {
            dta.append("RequestId", props.requestId);
        }

        await Api.saveFile(dta);   
    }
    
    await load();
};

const showDelete = async (file) => {
    const confirmed = await Alert.confirm("Are you sure you want to delete this file?");
    if (confirmed) {
        await Api.deleteFile(file.Id);
        await load();
    }
};

unwatch.push(watch(() => props.partId, async (nv, ov) => {
    if (nv) {
        await load();
    }
}, { immediate: true }));

onUnmounted(() => {
    unwatch.forEach((un) => {
        un();
    });
});
</script>

<style scoped>
.accordion-button:not(.collapsed) {
    background-color: #f8f9fa;
}
</style>
